import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { useAuth } from 'context/AuthContext';
import { getRewardFeed } from 'services/dashboard.service';

import { buildGallery, GalleryEntry, PersonSeedCard } from 'components/rebrand/recognized-gallery';

const FEED_SAMPLE_SIZE = 60;
const CARDS_TO_SHOW = 4;

export function RecentRecognizedPanel() {
  const { user, currentCycle } = useAuth();
  const [entries, setEntries] = useState<GalleryEntry[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    async function loadFeed() {
      try {
        const data = await getRewardFeed(currentCycle?.date_start, currentCycle?.date_finish, 0, FEED_SAMPLE_SIZE);
        setEntries(buildGallery(data?.result || []).slice(0, CARDS_TO_SHOW));
      } catch (e) {
        setEntries([]);
      }
      setLoaded(true);
    }

    if (!!user && !!currentCycle) {
      loadFeed();
    }
  }, [user, currentCycle]);

  if (!loaded) return null;

  return (
    <section className="rb-recent">
      <div className="rb-section-head">
        <div className="rb-section-head__title">
          <span className="rb-livedot rb-livedot--primary" />
          <h2>Últimos reconhecidos</h2>
        </div>
        <Link to="/galeria" className="rb-section-head__link">
          Ver galeria completa →
        </Link>
      </div>

      {entries.length > 0 ? (
        <div className="rb-hero-grid">
          {entries.map((entry, i) => (
            <PersonSeedCard key={entry.playerId} entry={entry} index={i} />
          ))}
        </div>
      ) : (
        <div className="rb-empty">Ainda não há reconhecimentos neste ciclo. Seja o primeiro a reconhecer um colega.</div>
      )}
    </section>
  );
}
